import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DemoHomeComponent } from './demo-home/demo-home.component';
import { DemoHomeModule } from './demo-home/demo-home.module';

const routes: Routes = [
  {
    path: 'button',
    loadChildren: async () =>
      (await import(/* webpackChunkName: "demo-button" */ `./demo-button/demo-button.module`)).DemoButtonModule,
  },
  {
    path: 'pill',
    loadChildren: async () =>
      (await import(/* webpackChunkName: "demo-pill" */ `./demo-pill/demo-pill.module`)).DemoPillModule,
  },
  {
    path: 'input',
    loadChildren: async () =>
      (await import(/* webpackChunkName: "demo-input" */ `./demo-input/demo-input.module`)).DemoInputModule,
  },
  {
    path: 'input-area',
    loadChildren: async () =>
      (await import(/* webpackChunkName: "demo-input-area" */ `./demo-input-area/demo-input-area.module`)).DemoInputAreaModule,
  },
  {
    path: 'input-color',
    loadChildren: async () =>
      (await import(/* webpackChunkName: "demo-input-color" */ `./demo-input-color/demo-input-color.module`)).DemoInputColorModule,
  },
  {
    path: 'input-tooltips',
    loadChildren: async () =>
      (await import(/* webpackChunkName: "demo-input-tooltips" */ `./demo-input-tooltips/demo-input-tooltips.module`)).DemoInputTooltipsModule,
  },
  {
    path: 'typeahead',
    loadChildren: async () =>
      (await import(/* webpackChunkName: "demo-typeahead" */ `./demo-typeahead/demo-typeahead.module`)).DemoTypeaheadModule,
  },
  {
    path: 'datepicker',
    loadChildren: async () =>
      (await import(/* webpackChunkName: "demo-datepicker" */ `./demo-datepicker/demo-datepicker.module`)).DemoDatepickerModule,
  },
  {
    path: 'error-handling',
    loadChildren: async () =>
      (await import(/* webpackChunkName: "demo-error" */ `./demo-error/demo-error.module`)).DemoErrorModule,
  },
  {
    path: 'error-icon',
    loadChildren: async () =>
      (await import(/* webpackChunkName: "demo-error-icon" */ `./demo-error-icon/demo-error-icon.module`)).DemoErrorIconModule,
  },
  {
    path: 'loading-spinner',
    loadChildren: async () =>
      (await import(/* webpackChunkName: "demo-spinner" */ `./demo-loading-spinner/demo-loading-spinner.module`)).DemoLoadingSpinnerModule,
  },
  {
    path: 'util-grid',
    loadChildren: async () =>
      (await import(/* webpackChunkName: "demo-util-grid" */ `./demo-utility-grid/demo-utility-grid.module`)).DemoUtilityGridModule,
  },
  {
    path: 'card',
    loadChildren: async () =>
      (await import(/* webpackChunkName: "demo-card" */ `./demo-card/demo-card.module`)).DemoCardModule,
  },
  {
    path: 'dropdown',
    loadChildren: async () =>
      (await import(/* webpackChunkName: "demo-dropdown" */ `./demo-dropdown/demo-dropdown.module`)).DemoDropdownModule,
  },
  {
    path: 'multiselect',
    loadChildren: async () =>
      (await import(/* webpackChunkName: "demo-multiselect" */ `./demo-multiselect/demo-multiselect.module`)).DemoMultiselectModule,
  },
  {
    path: 'validations',
    loadChildren: async () =>
      (await import(/* webpackChunkName: "demo-validations" */ `./demo-validations/demo-validations.module`)).DemoValidationsModule,
  },
  {
    path: 'popup',
    loadChildren: async () =>
      (await import(/* webpackChunkName: "demo-popup" */ `./demo-popup/demo-popup.module`)).DemoPopupModule,
  },
  {
    path: 'popup-service',
    loadChildren: async () =>
      (await import(/* webpackChunkName: "demo-popup-service" */ `./demo-popup-service/demo-popup-service.module`)).DemoPopupServiceModule,
  },
  {
    path: 'radio-group',
    loadChildren: async () =>
      (await import(/* webpackChunkName: "demo-radio" */ `./demo-radio-group/demo-radio-group.module`)).DemoRadioGroupModule,
  },
  {
    path: 'checkbox',
    loadChildren: async () =>
      (await import(/* webpackChunkName: "demo-checkbox" */ `./demo-checkbox/demo-checkbox.module`)).DemoCheckboxModule,
  },
  {
    path: 'toggle',
    loadChildren: async () =>
      (await import(/* webpackChunkName: "demo-toggle" */ `./demo-toggle/demo-toggle.module`)).DemoToggleModule,
  },
  {
    path: 'pie-chart',
    loadChildren: async () =>
      (await import(/* webpackChunkName: "demo-pie-chart" */ `./demo-pie-chart/demo-pie-chart.module`)).DemoPieChartModule,
  },
  {
    path: 'stepper',
    loadChildren: async () =>
      (await import(/* webpackChunkName: "demo-stepper" */ `./demo-stepper/demo-stepper.module`)).DemoStepperModule,
  },
  {
    path: 'kanban-board',
    loadChildren: async () =>
      (await import(/* webpackChunkName: "demo-kanban-board" */ `./demo-kanban-board/demo-kanban-board.module`)).DemoKanbanBoardModule,
  },
  {
    path: 'scheduler',
    loadChildren: async () =>
      (await import(/* webpackChunkName: "demo-scheduler" */ `./demo-scheduler/demo-scheduler.module`)).DemoSchedulerModule,
  },
  {
    path: 'toast',
    loadChildren: async () =>
      (await import(/* webpackChunkName: "demo-toast" */ `./demo-toast/demo-toast.module`)).DemoToastModule,
  },
  {
    path: 'progress-bar',
    loadChildren: async () =>
      (await import(/* webpackChunkName: "demo-progress-bar" */ `./demo-progress-bar/demo-progress-bar.module`)).DemoProgressBarModule,
  },
  {
    path: 'file-upload',
    loadChildren: async () =>
      (await import(/* webpackChunkName: "demo-file-upload" */ `./demo-file-upload/demo-file-upload.module`)).DemoFileUploadModule,
  },
  {
    path: 'form-array',
    loadChildren: async () =>
      (await import(/* webpackChunkName: "demo-form-array" */ `./demo-form-array/demo-form-array.module`)).DemoFormArrayModule,
  },
  {
    path: 'dynamic-form',
    loadChildren: async () =>
      (await import(/* webpackChunkName: "demo-dynamic-form" */ `./demo-dynamic-form/demo-dynamic-form.module`)).DemoDynamicFormModule,
  },
  {
    path: 'dynamic',
    loadChildren: async () =>
      (await import(/* webpackChunkName: "demo-dynamic" */ `./demo-dynamic/demo-dynamic.module`)).DemoDynamicModule,
  },
  { path: '', component: DemoHomeComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      anchorScrolling: 'enabled',
      onSameUrlNavigation: 'reload',
    }),

    DemoHomeModule,
    // feature modules are lazy loaded
  ],
  exports: [ RouterModule ],
})
export class AppRoutingModule {
}
